import { Chip, Stack } from '@mui/material';
import PropTypes from 'prop-types';

// Hoisted: see Section.jsx. A nested `sx` literal is the most expensive kind to
// re-serialize, and this renders on every equipment row.
const CHIP_SX = { '& .MuiChip-label': { fontSize: '8px' }, height: '16px' };

const TagChip = ({ label }) => <Chip label={label} size="small" color="default" sx={CHIP_SX} />;

const TagChips = ({ showEquipment, showInventory }) => (
    <Stack direction="row" spacing={1}>
        {showEquipment && <TagChip label="Equipment" />}
        {showInventory && <TagChip label="Inventory" />}
    </Stack>
);

TagChips.propTypes = {
    showEquipment: PropTypes.bool,
    showInventory: PropTypes.bool,
};

export default TagChips;
